<div class="main-layout tds-u-h-100 tds-u-w-100 tds-u-overflow-hidden tds-u-flex tds-u-flex-dir-col">
  <app-header></app-header>
  <main class="main-content tds-u-flex">
    <app-side-nav></app-side-nav>
    <div class="content tds-u-flex tds-u-flex-dir-col tds-background-grey-50">
      <app-toast></app-toast>
      <app-spinner></app-spinner>
      <app-countdown-popup></app-countdown-popup>
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-floating-ball />
</div> 

<!-- <div class="main-layout tds-u-flex tds-u-h-100 tds-u-w-100 tds-u-overflow-hidden">
  <app-side-nav></app-side-nav>
  <main class="main-content tds-u-flex tds-u-flex-dir-col tds-u-flex-grow-1 tds-u-h-100">
    <app-header></app-header>
    
    <div class="content tds-u-flex tds-u-flex-dir-col tds-background-white">
      @if(!hideBreadcrumbs()) {
      }
      <app-toast></app-toast>
      <app-spinner></app-spinner>
      <app-countdown-popup></app-countdown-popup>
      <router-outlet></router-outlet>
    </div>
  </main>
</div>  -->